import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { storeName } from '../redux/models/layout.model';

const getVisibility = () => {
  let hidden = null;
  let visibilityChange = null;
  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
  } else if (typeof document['msHidden'] !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
  } else if (typeof document['webkitHidden'] !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  }

  return { hidden, visibilityChange };
};

const useDocumentVisibleChange = (): void => {
  const { hidden, visibilityChange } = getVisibility();

  const dispatch = useDispatch()[storeName];

  const handleActivity = (forcedFlag: any) => {
    if (typeof forcedFlag === 'boolean') {
      return forcedFlag ? dispatch.setActivityWindow(true) : dispatch.setActivityWindow(false);
    }

    return document[hidden] ? dispatch.setActivityWindow(false) : dispatch.setActivityWindow(true);
  };

  useEffect(() => {
    const handleActivityFalse = () => handleActivity(false);
    const handleActivityTrue = () => handleActivity(true);

    if (visibilityChange) {
      document.addEventListener('visibilitychange', handleActivity, false);
    }

    window.addEventListener('blur', handleActivityFalse, false);
    document.addEventListener('blur', handleActivityFalse, false);
    window.addEventListener('focus', handleActivityTrue, false);
    document.addEventListener('focus', handleActivityTrue, false);

    return () => {
      if (visibilityChange) {
        document.removeEventListener('visibilitychange', handleActivityTrue, false);
      }

      window.removeEventListener('blur', handleActivity, false);
      document.removeEventListener('blur', handleActivityFalse, false);
      window.removeEventListener('focus', handleActivityFalse, false);
      document.removeEventListener('focus', handleActivityTrue, false);
    };
  }, []);
};

export default useDocumentVisibleChange;
